import _ from "underscore";
import { useMemo } from "react";

const useDebounceCallback = (callback: (...args: any) => any, wait: number, deps: ReadonlyArray<unknown>) => {
    const debouncedCallback = useMemo(() => _.debounce(callback, wait), deps);
    return debouncedCallback;
};

export default useDebounceCallback;